import React from 'react';
import { GraduationCap } from 'lucide-react';

// Closing "educational purpose" note for engineering tools: blue (informational), not the
// amber safety disclaimer. `scope` names what varies between real cases for this tool.
const ToolEducationalNote = ({ scope, className = 'mt-4 text-[11px]' }) => (
  <div
    role="note"
    data-testid="tool-educational-note"
    className={`flex items-start gap-3 rounded-xl border border-autoxium-blue/30 bg-autoxium-blue/5 p-4 leading-relaxed ${className}`}
  >
    <GraduationCap className="h-5 w-5 shrink-0 text-autoxium-blue mt-0.5" aria-hidden="true" />
    <p className="text-foreground/80">
      <strong className="text-foreground">For educational purposes.</strong>{' '}
      This tool is meant for learning and first-pass estimates. Real results differ from case to
      case{scope ? ` — ${scope}` : ''}. Treat the numbers as a starting point and confirm the final
      design by test or with the component supplier.
    </p>
  </div>
);

export default ToolEducationalNote;
